import { Dispatch, FC, SetStateAction, useMemo } from "react";
import { useLocation } from "react-router-dom";
import AppAsideNavigationDefinitionItem, {
  AppAsideNavigationDefinitionGroup,
} from "../common/types/app-aside-navigation-definition";
import AppAsideExpandedNavigationGroupListItemComponent from "./app-aside-expanded-navigation-group-list-item.component";
import AppAsideExpandedNavigationLinkListItemComponent from "./app-aside-expanded-navigation-link-list-item.component";
import appAsideExpandedNavigationFactory from "./common/app-aside-expanded-navigation.factory";
import appAsideExpandedNavigationHelper from "./common/app-aside-expanded-navigation.helper";
import MetaAttentionCounters from "../../../../common/services/meta/attention-counters/meta-attention-counters";

type AppAsideExpandedNavigationProps = {
  attentionCountersData: MetaAttentionCounters | null;
  expandedGroupsKeys: string[];
  isExpanded: boolean;
  navigationDefinition: AppAsideNavigationDefinitionItem[];
  setExpandedGroupsKeys: Dispatch<SetStateAction<string[]>>;
};

const AppAsideExpandedNavigationComponent: FC<
  AppAsideExpandedNavigationProps
> = (props) => {
  const { pathname } = useLocation();

  const navigationItems = useMemo(() => {
    return appAsideExpandedNavigationFactory.createNavigationItems(
      props.navigationDefinition,
      props.expandedGroupsKeys,
      pathname,
    );
  }, [props.navigationDefinition, props.expandedGroupsKeys, pathname]);

  const toggleGroup = (
    groupKey: AppAsideNavigationDefinitionGroup["key"],
    isExpanded: boolean,
  ) => {
    if (isExpanded) {
      props.setExpandedGroupsKeys((keys) =>
        keys.filter((key) => key !== groupKey),
      );
      return;
    }

    props.setExpandedGroupsKeys((keys) => [...keys, groupKey]);
  };

  return (
    <nav className="app_aside_navigation">
      <div className="app_aside_navigation_list">
        <ul>
          {navigationItems.map((item) => {
            const isGroup = appAsideExpandedNavigationHelper.checkIsGroup(item);

            if (isGroup) {
              return (
                <AppAsideExpandedNavigationGroupListItemComponent
                  key={`navigation-list-item-key-${item.key}`}
                  group={item}
                  onToggleClick={toggleGroup}
                  idForTesting={`app-aside-navigation-list-item-${item.key}-group`}
                />
              );
            }

            return (
              <AppAsideExpandedNavigationLinkListItemComponent
                key={`navigation-list-item-key-${item.key}`}
                link={item}
                idForTesting={`app-aside-navigation-list-item-${item.key}-link`}
              />
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default AppAsideExpandedNavigationComponent;
